<template>
    <div>
        <div v-if = "header">
            <div class="navigation-header pr-2">
                <div class = "navigation-col-header remove-button pl-4">
                    <v-icon >mdi-trash-can-outline</v-icon>
                </div>
                <div class = "navigation-col-header elevator">
                    {{ $t('inc.unit.elevatorNo') }}
                </div>
                <div class = "navigation-col-header assessmentType">
                    {{$t('inc.assessment.type') }}
                </div>
                <div class = "navigation-col-header assessmentResult">
                    {{ $t('inc.assessment.result') }}
                </div>
                <div class = "navigation-col-header date">
                    {{ $t('inb.detail.assessment.date') }}
                </div>
            </div>
        </div>

        <v-hover
            v-if  =  "!header"
            v-slot = "{ hover }"
        >
            <div
                v-if   = "unit"
                class  = "navigation-entry"
                :class = "border2"
            >
                <div
                    class="remove-button"
                    :class = "background(hover)"
                >
                    <a @click="onRemove">
                        <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                    </a>
                </div>
                <div
                    class  = "elevator"
                    :class = "background(hover)"
                >
                    {{ unit.fabricNo }}
                </div>
                <div
                    class  = "assessmentType"
                    :class = "background(hover)"
                >
                    {{ assessmentType }}
                </div>
                <div
                    class  = "assessmentResult"
                    :class = "background(hover)"
                >
                    {{ assessmentResult }}
                </div>
                <div
                    class  = "date"
                    :class = "background(hover)"
                >
                    {{ assessmentDate }}
                </div>
            </div>
        </v-hover>
    </div>
</template>

<script>

import PIncNavigationMixin from "@/modules/inc/steps/components/navigation/private/PIncNavigationMixin";

export default {
    name: "PIncNavigationEntryAssessment",

    components: {
    },

    mixins: [
        PIncNavigationMixin
    ],

    computed: {
        assessmentType () {
            return this.entry && this.entry.type ? this.entry.type.name : '---'
        },

        assessmentResult () {
            return this.entry && this.entry.result ? this.entry.result.name : '---'
        },

        assessmentDate () {
            return this.entry ? this.dateAsString (this.entry.dateAssessment) : '---'
        }
    },
}
</script>

<style scoped>

.assessmentType {
    width: 32%;
    text-align: left;
}

.assessmentResult {
    width: 23%;
    text-align: left;
}

.date {
    width: 15%;
    text-align: left;
}

.date, .assessmentType, .assessmentResult, .elevator {
    font-size: 15px;
    padding-top: 5px;
}

</style>